import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from './AuthProvider.jsx';

/**
 * Gate for routes that require a session.
 *   - 'loading'      → show a neutral loading screen
 *   - 'anonymous'    → redirect to /login and remember where we came from
 *   - 'authenticated'→ render children
 *
 * Use with nested routes via React Router's <Outlet />:
 *   <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
 *     <Route index element={<Dashboard />} />
 *   </Route>
 */
export function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullScreenLoader />;

  if (status === 'anonymous') {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  return children;
}

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center text-t3">
      <Loader2 className="w-5 h-5 animate-spin mr-2" />
      Loading…
    </div>
  );
}
